import { z } from "zod";

const errorMessages = {
  required: "وارد کردن این فیلد اجباری است",
};

const schema = z.object({
  name: z.string().min(1, errorMessages.required),
  faculty: z.string().min(1, errorMessages.required),
  fields: z.array(z.string()).min(1, errorMessages.required),
});

export { schema };
